import { expenseService } from '../services/api';

// Helper to get the correct preview URL (with token for server URLs)
export function getPreviewUrl(url) {
  if (!url) return null;
  // Blob URLs don't need token
  if (url.startsWith('blob:')) return url;
  return expenseService.getFileUrl(url);
}
